// extracted by mini-css-extract-plugin
export var chevronIcon = "_8m-2";
export var teamName = "_8m-1";
export var teamSwitcherButton = "_8m-0";